export const TYPE_FETCHING = 'TYPE_FETCHING' as const;
export const TYPE_FETCHED = 'TYPE_FETCHED' as const;
export const TYPE_ERROR = 'TYPE_ERROR' as const;
